const paymentTypes = {
  ecommerce: 'order',
  subscription: 'subscription',
  subscriptionAndEcommerce: 'subscriptionAndEcommerce',
  giftSubscription: 'giftSubscription',
  giftSubscriptionRedeem: 'giftSubscriptionRedeem',
  coupon: 'coupon',
  giftCard: 'giftCard',
  giftRedeem: 'giftRedeem',
  updateInfo: 'updateInfo',
  buyQueue: 'buyQueue',
  redeemQueue: 'redeemQueue', // @deprecated, use "buyQueue" instead
} as const

export type PaymentType = keyof typeof paymentTypes


export default paymentTypes
